import { createApp } from 'vue';

import Main from './Main.vue';
const ac = document.querySelector('.for-login .form-signin.form-login .page-card-actions');
if (ac) {
	const root = document.createElement('div');
	ac.parentElement?.insertBefore(root, ac.nextSibling);
	createApp(Main).mount(root);
}
